import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }

import { IonModal } from '@ionic/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MyModal',
  props: {
  modelValue: { type: Boolean, required: true },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {



const emit = __emit;

function onDidDismiss() {
  emit('update:modelValue', false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    class: "modal-default",
    "is-open": __props.modelValue,
    onDidDismiss: onDidDismiss
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["is-open"]))
}
}

})